/* eslint-disable sort-keys-fix/sort-keys-fix */
import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

export const EXPANDABLE_COMPONENT = 'Expandable component';

export const COMMON_COMPONENTS_EVENTS = Object.freeze({
  EXPANDABLE_CLICK: (name: string) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    category: EXPANDABLE_COMPONENT,
    name,
  }),
});
